import { create } from 'zustand';
import { TypeGlobalTradeDataFormSearch } from 'src/utils/typings/dto/tradeData';

interface ITradeDataSearchFormState {
  formValues?: TypeGlobalTradeDataFormSearch;
  isFormFinishInitialize?: boolean;
  update: (formValues: TypeGlobalTradeDataFormSearch, isFormFinishInitialize: boolean) => void;
}

export const useTradeDataSearchFormState = create<ITradeDataSearchFormState>((set) => ({
  update: (formValues, isFormFinishInitialize) => {
    set({ formValues, isFormFinishInitialize });
  },
}));
